export default function Aprendizado() {
  const situacoes = [
    {
      icon: 'ri-capsule-line',
      text: 'quando o paciente recusa tomar remédio'
    },
    {
      icon: 'ri-water-flash-line',
      text: 'quando ele não quer tomar banho'
    },
    {
      icon: 'ri-repeat-2-line',
      text: 'quando faz a mesma pergunta várias vezes'
    },
    {
      icon: 'ri-question-answer-line',
      text: 'quando surgem acusações ou desconfiança'
    },
    {
      icon: 'ri-fire-line',
      text: 'quando aparece agitação ou irritação'
    },
    {
      icon: 'ri-user-unfollow-line',
      text: 'quando não reconhece familiares'
    }
  ];

  return (
    <section className="py-12 sm:py-20 bg-gradient-to-b from-white to-teal-50/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">

        {/* Eyebrow */}
        <p className="text-center text-xs sm:text-sm font-semibold tracking-widest text-teal-600 uppercase mb-3 sm:mb-4">
          Situações que o protocolo ajuda a resolver
        </p>

        {/* Título */}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-10 sm:mb-14 leading-tight">
          Situações comuns que você vai aprender a conduzir
        </h2>

        {/* Lista de situações */}
        <div className="grid sm:grid-cols-2 gap-4 sm:gap-5">
          {situacoes.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-4 bg-white border border-teal-100 rounded-xl px-5 py-4 hover:border-teal-300 transition-colors duration-200"
            >
              {/* Check */}
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-teal-600 rounded-full">
                <i className="ri-check-line text-white text-sm"></i>
              </div>
              {/* Ícone situação */}
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 text-teal-500">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <p className="text-gray-800 text-sm sm:text-base font-medium leading-snug">
                {item.text}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
